<div class="review-rate__item" (click)="onClickItem()">
  <ng-content></ng-content>
</div>